import {gql} from "apollo-angular";


export var update_company_event_info = gql`
    mutation updateCompanyEvent(
      $id: ID!,
      $title: String,
      $is_sponsored: Boolean,
      $sponsorship_amount:Int,
      $is_cosponsored:Boolean,
      $cosponsor: String,
      $is_cancelled: Boolean,
      $is_postponed: Boolean,
      $company_event_type_id: ID,
      $notes: String,
      $event_date_id: ID!,
      $start_date: Date,
      $end_date: Date,
      $start_time: String,
      $end_time: String,
      $timezone: String,
      $initial_date_time: Int
    ){
      updateEventInfo(
        id: $id,
        title: $title,
        is_sponsored: $is_sponsored,
        company_event_type_id: $company_event_type_id,
        sponsorship_amount: $sponsorship_amount,
        is_cosponsored: $is_cosponsored,
        cosponsor: $cosponsor,
        is_cancelled: $is_cancelled,
        is_postponed: $is_postponed,
        notes: $notes
      ){
        id
        title
        notes
      }
      updateCompanyEventDate(
        id: $event_date_id,
        start_date: $start_date,
        end_date: $end_date,
        start_time: $start_time,
        end_time: $end_time,
        timezone: $timezone,
        initial_date_time: $initial_date_time
      ){
        id
        start_date
        end_date
        id
        initial_date_time
        start_time
        timezone
        end_time
      }
    }
`
export var update_note = gql`
    mutation updateNote($id: ID!, $notes: String){
      updateNote(id: $id, notes: $notes){
        notes
        id
        title
      }
    }
`

export var delete_company_event = gql`
    mutation deleteCompanyEvent($id: ID!){
      deleteCompanyEvent(id: $id){
        id
      }
    }
`

export var update_company_event_external_link = gql`
    mutation updateWebAddress($id: ID!, $protocol: Int, $subdomain: String, $domain: String!, $tld: String, $path: String, $parameters: String, $companyEventWebAddress: CreateCompanyEventWebAddressHasOne!){
      updateWebAddress(id: $id, protocol: $protocol, subdomain: $subdomain, domain: $domain, tld: $tld, path: $path, parameters: $parameters, companyEventWebAddress: $companyEventWebAddress){
        protocol
        subdomain
        id
        domain
        tld
        path
        parameters
        companyEventWebAddress {
          id
          name
        }
      }
    }
`

export var update_date_time = gql`
    mutation updateCompanyEventDate(
      $event_date_id: ID!,
      $start_date: Date,
      $end_date: Date,
      $start_time: String,
      $end_time: String,
      $timezone: String,
      $initial_date_time: Int
    ){
      updateCompanyEventDate(
        id: $event_date_id,
        start_date: $start_date,
        end_date: $end_date,
        start_time: $start_time,
        end_time: $end_time,
        timezone: $timezone,
        initial_date_time: $initial_date_time
      ){
        id
        start_date
        end_date
        initial_date_time
        start_time
        timezone
        end_time
      }
    }
`
export var delete_web_address = gql`
    mutation deleteWebAddress($id: ID!){
      deleteWebAddress(id: $id){
        id
      }
    }
`

export var delete_company_event_external_file = gql`
    mutation deleteCompanyEventFile($id: ID!){
      deleteCompanyEventFile(id: $id){
        id
      }
    }
`

export var create_company_event_attendee = gql`
    mutation createCompanyEventAttendee($company_event_id: ID!, $person_id: ID!, $is_registered: Boolean!){
      createCompanyEventAttendee(company_event_id: $company_event_id, person_id: $person_id, is_registered: $is_registered){
        id
        is_registered
        person {
          id
          name
        }
      }
    }
`

export var update_company_event_attendee = gql`
    mutation updateCompanyEventAttendee($id: ID!, $is_registered: Boolean!){
      updateCompanyEventAttendee(id: $id, is_registered: $is_registered){
        id
        is_registered
        person {
          id
          name
        }
      }
    }
`

export var delete_company_event_attendee = gql`
    mutation deleteCompanyEventAttendee($id: ID!){
      deleteCompanyEventAttendee(id: $id){
        id
      }
    }
`

export var delete_crea_outlook_event = gql`
    mutation deleteCreaOutlookEvent($id: ID!, $outlook_id: ID!){
      deleteCreaOutlookEvent(id: $id){
        id
      }
      deleteOutlookEvent(id: $outlook_id){
        id
      }
    }
`

